export class ToggledEvent extends Event {
    toggledState: boolean;

    constructor(toggledState: boolean) {
        super('toggled', { bubbles: true, composed: true });
        this.toggledState = toggledState;
    }
}